import React, { PureComponent } from 'react';
import { func, string } from 'prop-types';
import classnames from 'classnames';
import { Icons } from 'components';
import debounce from 'lodash/debounce';
import './SearchInput.scss';

export default class SearchInput extends PureComponent {
    debouncedSearchForItems = debounce((value, evt) => {
        const { onSearch } = this.props;
        if (onSearch) onSearch(value, evt);
    }, 100);

    static propTypes = {
        className: string,
        placeholder: string,
        onSearch: func,
        onSubmit: func,
    };

    static defaultProps = {
        className: null,
        placeholder: 'Chercher ici...',
        onSearch: null,
        onSubmit: null,
    };

    state = {
        searchValue: '',
    };

    clearSearchValue = () => {
        const { onSearch } = this.props;
        this.setState({ searchValue: '' });
        if (onSearch) onSearch('');
    };

    handleInputSearchChange = evt => {
        evt.preventDefault();
        evt.stopPropagation();

        const searchValue = evt.target.value;
        this.setState({ searchValue }, () => {
            this.debouncedSearchForItems(searchValue, evt);
        });
    };

    handleSubmit = evt => {
        evt.preventDefault();
        const { onSubmit } = this.props;
        if (onSubmit) onSubmit(evt);
    };

    render() {
        const { className, placeholder } = this.props;
        const { searchValue } = this.state;

        const rootClassnames = classnames('dropdown-search', className);

        return (
            <div className={rootClassnames}>
                <form
                    noValidate
                    className="dropdown-search__form"
                    role="search"
                    onSubmit={this.handleSubmit}
                >
                    <input
                        className="dropdown-search__form__input"
                        type="search"
                        placeholder={placeholder}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck={false}
                        required
                        maxLength={512}
                        value={searchValue}
                        onChange={this.handleInputSearchChange}
                    />
                    <button
                        type="reset"
                        title="Clear the search query."
                        className="dropdown-search__form__reset"
                        hidden={!searchValue.length}
                        onClick={this.clearSearchValue}
                    >
                        <Icons.Close
                            className="dropdown-search__form__reset__icon"
                            width="10"
                            height="10"
                        />
                    </button>
                </form>
            </div>
        );
    }
}
